import type { RequestRow } from "../components/CXAutomationApiSetupSection/components/RequestKeyValueRow";

export const rowsToObject = (rows: RequestRow[]): Record<string, string> => {
  const result: Record<string, string> = {};
  rows.forEach((row) => {
    const key = row.key.trim();
    if (!key) return;
    result[key] = row.value;
  });
  return result;
};

// Body values are entered as plain text but may represent structured JSON
// (arrays, objects, booleans, null). Parse those so they keep their type when
// sent — but leave bare numbers/strings alone (avoids mangling zip codes,
// phone numbers, ids with leading zeros, etc.).
export const parseRowValue = (value: string): unknown => {
  const trimmed = value.trim();
  if (trimmed === "true" || trimmed === "false" || trimmed === "null") {
    return JSON.parse(trimmed);
  }
  if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
    try {
      return JSON.parse(trimmed);
    } catch {
      return value;
    }
  }
  return value;
};

export const rowsToBody = (rows: RequestRow[]): Record<string, unknown> => {
  const result: Record<string, unknown> = {};
  rows.forEach((row) => {
    const key = row.key.trim();
    if (!key) return;
    result[key] = parseRowValue(row.value);
  });
  return result;
};

export const appendQueryParams = (
  baseUrl: string,
  rows: RequestRow[]
): string => {
  const pairs = rows
    .filter((row) => row.key.trim())
    .map(
      (row) =>
        `${encodeURIComponent(row.key.trim())}=${encodeURIComponent(row.value)}`
    );
  if (!pairs.length) return baseUrl;
  const separator = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${separator}${pairs.join("&")}`;
};
